export default __webpack_public_path__ + "static/media/BG-HEINRICH_Desktop.d4b76a7c.jpg";